import {
    Box,
    Collapse,
    Modal,
    IconButton,
    ListItem,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import ClearIcon from '@mui/icons-material/Clear';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';

import SchedulePreview from './SchedulePreview';
import ScheduleCard from './ScheduleCard';
import ScheduleInputs from './ScheduleInputs';

const ScheduleListItem = ({ fieldPath, handleRemove, kansanopisto, setHours }) => {
    const { getFieldState } = useFormContext();

    const [collapseOpen, setCollapseOpen] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = (e) => {
        e.stopPropagation();
        setModalOpen((prevModal) => !prevModal);
    };

    const toggleCollapse = (e) => {
        e.stopPropagation();
        setCollapseOpen((prevCollapse) => !prevCollapse);
    };

    const fieldState = getFieldState(fieldPath);
    const hasErrors = !!fieldState.error;

    const listItemStyle = {
        border: '1px solid',
        borderRadius: 2,
        borderColor: !hasErrors ? 'taphaWhite.main' : 'taphaErrorRed.dark',
        backgroundColor: !hasErrors ? 'taphaWhite.main' : 'taphaErrorRed.main',
        mt: 1,
        gap: 1,
        display: 'flex',
        flexDirection: 'column',
        '&:hover': !collapseOpen && !hasErrors && {
            border: '1px solid',
            borderColor: 'taphaGreen.main',
            cursor: 'pointer',
        },
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '90vw', sm: '70vw', md: '50vw' },
        maxWidth: { xs: '95vw', md: '600px' },
        maxHeight: '90vh',
        bgcolor: 'white',
        boxShadow: 3,
        borderRadius: 2,
        p: { xs: 2, sm: 3 },
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
    };

    return (
        <>
            <ListItem
                onClick={toggleCollapse}
                disableGutters
                disablePadding
                sx={listItemStyle}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-evenly',
                        width: '100%',
                    }}
                >
                    <IconButton disableRipple sx={{ ml: 1 }}>
                        {collapseOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    <SchedulePreview name={fieldPath} hasErrors={hasErrors} />
                    <IconButton disableRipple onClick={toggleModal}>
                        <EditIcon sx={{ color: 'taphaBlue.dark' }} />
                    </IconButton>
                    <IconButton disableRipple onClick={handleRemove}>
                        <ClearIcon sx={{ color: 'taphaBlue.dark' }} />
                    </IconButton>
                </Box>
                <Collapse
                    sx={{ width: '100%' }}
                    unmountOnExit
                    in={collapseOpen}
                    timeout="auto"
                >
                    <ScheduleCard fieldName={fieldPath} hasErrors={hasErrors} />
                </Collapse>
            </ListItem>
            <Modal open={modalOpen} onClose={toggleModal} keepMounted>
                <Box sx={modalStyle}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2,
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'medium' }}>
                            Muokkaa tilaisuutta
                        </Typography>
                        <IconButton onClick={toggleModal}>
                            <ClearIcon sx={{ color: 'taphaBlue.dark' }} />
                        </IconButton>
                    </Box>
                    <ScheduleInputs
                        kansanopisto={kansanopisto}
                        fieldName={fieldPath}
                        setHours={setHours}
                        onClose={() => setModalOpen(false)}
                    />
                </Box>
            </Modal>
        </>
    );
};

ScheduleListItem.propTypes = {
    fieldPath: PropTypes.string,
    handleRemove: PropTypes.func,
    kansanopisto: PropTypes.any,
    setHours: PropTypes.func,
};

export default ScheduleListItem;